module.exports = __webpack_public_path__ + "static/media/maples-of-novi.5987c21c.pdf";